// extracted by mini-css-extract-plugin
module.exports = {"box":"style__box__CYV1l","button":"style__button__gGY0c"};